import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const Profile = () => {

    const [user, setUser] = useState({});
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState("");


//   const BASE_URL = "http://localhost:8080";
  const BASE_URL = "https://dbbackend.hmtbasic2ai.info";

    // =========================
    // FETCH USER DETAILS
    // =========================
    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.get(
                `${BASE_URL}/api/users/profile`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            console.log(res.data)
            setUser(res.data);

        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    // =========================
    // IMAGE SELECT
    // =========================
    const handleFileChange = (e) => {
        const selected = e.target.files[0];

        if (selected) {
            setFile(selected);
            setPreview(URL.createObjectURL(selected));
        }
    };

    // =========================
    // UPLOAD IMAGE
    // =========================
    const handleUpload = async () => {
        try {
            if (!file) {
                Swal.fire({
                    icon: "warning",
                    title: "No Image Selected",
                    text: "Please select a profile image first"
                });
                return;
            }

            const formData = new FormData();
            formData.append("file", file);

            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${BASE_URL}/api/file/upload/profile_pic`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            Swal.fire({
                icon: "success",
                title: "Uploaded!",
                text: "Profile image updated successfully"
            });

            setFile(null);
            setPreview("");

            fetchProfile();

        } catch (err) {
            console.log(err);

            Swal.fire({
                icon: "error",
                title: "Upload Failed",
                text: err.response?.data?.message || "Something went wrong"
            });
        }
    };

    const handleDelete = async (fileId) => {

        try {
           if (fileId) {
             // ✅ Confirmation popup
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "This file will be moved to trash.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
            });

            // ❌ If cancelled
            if (!result.isConfirmed) return;

            const token = localStorage.getItem("token");

            // 🚀 API call
            const res = await axios.put(
                `${BASE_URL}/api/file/upload/delete/profile_pic`,
                { file_id: fileId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            // ✅ Success alert
            Swal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: "File has been moved to trash.",
                    timer: 1500,
                    showConfirmButton: true
                }).then(() => {
                    // console.log(res.data);
                     window.location.reload(true);
                });

             

            // 🔄 Optional: refresh list here
            fetchProfile();
           }
           else{
            Swal.fire({
                    icon: "warning",
                    title: "Abort!",
                    text: "File is not available.",
                    //timer: 1500,
                    showConfirmButton: true
                })
           }

        } catch (err) {

            console.log(err);

            Swal.fire({
                icon: "error",
                title: "Delete Failed",
                text: err.response?.data?.message || "Something went wrong",
            });
        }
    };
    return (
        <div className="p-3 bg-light">

            {/* TITLE */}
            <div className="fs-3 fw-bold">User Profile</div>
            <hr />
            {/* <button className="btn btn-sm btn-danger rounded-0 mx-1" onClick={()=>handleDelete(user.profile_id)}><i class="bi bi-trash3"></i>Delete</button> */}
            {/* PROFILE CARD */}
            <div className="row">

                {/* LEFT: IMAGE */}
                <div className="col-md-3 text-center col-sm-12 border py-2 white border-3">

                    <center className="">
                        <img
                        src={
                            preview ||
                            `${BASE_URL}/files/${user.profile_name || "default.png"}`
                        }
                        alt={`${user.profile_name?'user.profile_name':'No Pic'}`}
                        className="img-fluid rounded-circle border shadow-sm "
                        style={{
                            width: "180px",
                            height: "180px",
                            objectFit: "cover"
                        }}
                    />
                    </center>

                    <div className="mt-3">
                        <input
                            type="file"
                            accept="image/*"
                            className="form-control"
                            onChange={handleFileChange}
                        />
                    </div>
                    <hr/>
                    <div className="d-flex">
                        <button
                            className="btn btn-primary rounded-0 mt-2 w-100"
                            onClick={handleUpload}
                        >
                            Upload
                        </button>
                        <button className="btn btn-danger mt-2 w-100 rounded-0 " onClick={()=>handleDelete(user.profile_id)}><i class="bi bi-trash3"></i>Delete</button>
                    </div>
                </div>

                {/* RIGHT: DETAILS */}
                <div className="col-md-9 col-sm-12">

                    <ul className="list-group">

                        <li className="list-group-item">
                            <b>Tile:</b> {user.TITLE}
                        </li>
                        <li className="list-group-item">
                            <b>First Name:</b> {user.FIRST_NAME}
                        </li>
                        <li className="list-group-item">
                            <b>Last Name:</b> {user.LAST_NAME}
                        </li>
                        <li className="list-group-item">
                            <b>Gender:</b> {user.SEX==='M' ? 'Male':user.SEX==='F' ? 'Female':'Others'}
                        </li>
                        <li className="list-group-item">
                            <b>Date of Birth:</b>{" "}
                            {user.DATE_OF_BIRTH
                                ? new Date(user.DATE_OF_BIRTH).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                }).replace(/ /g, "-")
                                : "-"}
                        </li>
                        <li className="list-group-item">
                            <b>User:</b> {user.user_name}
                        </li>
                         <li className="list-group-item">
                            <b>Description:</b> {user.description}
                        </li>
                        <li className="list-group-item">
                            <b>Phone:</b> {user.PHONE_NUMBER}
                        </li>
                        <li className="list-group-item">
                            <b>Email:</b> {user.EMAIL_ADDRESS}
                        </li>
                        <li className="list-group-item">
                            <b>Address:</b> {user.address}
                        </li>
                        <li className="list-group-item">
                            <b>Town:</b> {user.TOWN_OF_BIRTH}
                        </li>
                        <li className="list-group-item">
                            <b>Country:</b> {user.NATIONALITY}
                        </li>
                        <li className="list-group-item">
                         <b>Active From:</b>{" "}
                        {user.EFFECTIVE_START_DATE
                            ? new Date(user.EFFECTIVE_START_DATE).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            }).replace(/ /g, "-")
                            : "-"}
                    </li>

                    </ul>

                </div>

            </div>

        </div>
    );
};

export default Profile;